import { PositionOptions, TypeOptions } from 'react-toastify'

export enum ApiActionTypes {
  REJECTED = '@@general/REJECTED',
}

export interface ToastifyDetail {
  position?: PositionOptions
  message: string
  type: TypeOptions
  duration?: number
  icon?: 'check-circle' | 'delete' | 'stop' | 'plus-circle' | 'warning'
  hideProgressBar?: boolean
}
